import { Component, Element, h, Host } from '@stencil/core';

@Component({
  tag: 'wink-intent-bar',
  styleUrl: 'styles/intent-bar.default.scss',
  shadow: true,
})
export class IntentBar {
  @Element() host!: HTMLWinkIntentBarElement;

  render() {
    return (
      <Host>
        <slot />
      </Host>
    );
  }
}
